<template>
  <div id="contenedor-infraestructura-toolbar">
    <v-toolbar
    flat
    dense>
    <div
      style="width: 150px" class="mr-2">
      <ejercicio-picker
        v-model="filtros.ejercicio"
        class="mr-2">
      </ejercicio-picker>
    </div>
    <div
      style="width: 350px"
      class="mr-2">
      <custom-text-field
        label="Buscar..."
        append-icon="mdi-magnify"
        clearable
        @keyup="buscar"
        @click:clear="limpiarBuscadorTexto">
      </custom-text-field>
    </div>
    <v-spacer></v-spacer>
    <custom-button
      v-if="mixValidaScopesActions(1)"
      label="Nueva"
      iconText="mdi-plus"
      tipo="agregar"
      @click="nuevaInfraestructura"
      >
    </custom-button>
  </v-toolbar>
  </div>
</template>

<script>
import CustomButton from '@/components/buttons/Button.vue';
import CustomTextField from '@/components/inputs/sinColumnas/TextField.vue';
import EjercicioPicker from '@/components/inputs/EjercicioPicker.vue';

export default {
  name: 'ToolBarInfraestructura',
  props: {
    filtros: {
      type: Object,
      required: true,
    },
  },
  components: {
    CustomButton,
    CustomTextField,
    EjercicioPicker,
  },
  data() {
    return {};
  },
  methods: {
    buscar(e) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.filtros.buscarTexto = e.target.value;
      }, 600);
    },
    limpiarBuscadorTexto() {
      this.filtros.buscarTexto = '';
    },
    nuevaInfraestructura() {
      this.$emit('agregarInfraestructura');
    },
  },

};
</script>

<style lang="scss">

</style>
